import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { router } from './';

export default function RoutingProvider() {
    return <BrowserRouter basename={''}>{router.render()}</BrowserRouter>;
}
